module.exports = __webpack_public_path__ + "img/patour.1033530e.jpg";